module.exports = __webpack_public_path__ + "static/media/vuelos.657d78bc.svg";